module.exports = __webpack_public_path__ + "img/dianxin001-1.be052513.png";